import { useGlobalStore } from '@highlight/ipc/react'
import { getDefaultTriggerHotkey } from '@shared/store/impl/settings.ts'

const useTriggerHotkey = (): string => {
  const [hotkey] = useGlobalStore<string>('settings', 'triggerHotkey', getDefaultTriggerHotkey())
  return hotkey
}

export default useTriggerHotkey
